var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83333 8.1665H5.5V9.83317H3.83333V8.1665ZM15.5 3.99984V15.6665C15.5 16.5832 14.75 17.3332 13.8333 17.3332H2.16667C1.24167 17.3332 0.5 16.5832 0.5 15.6665L0.508333 3.99984C0.508333 3.08317 1.24167 2.33317 2.16667 2.33317H3V0.666504H4.66667V2.33317H11.3333V0.666504H13V2.33317H13.8333C14.75 2.33317 15.5 3.08317 15.5 3.99984ZM2.16667 5.6665H13.8333V3.99984H2.16667V5.6665ZM13.8333 15.6665V7.33317H2.16667V15.6665H13.8333ZM10.5 9.83317H12.1667V8.1665H10.5V9.83317ZM7.16667 9.83317H8.83333V8.1665H7.16667V9.83317Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/calenderIcon.0cb15ac504851e497c7c79b2abbdaa0e.svg";
export { ForwardRef as ReactComponent };